import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { InvoicesService } from '../services/invoices.service';
import { Invoice } from '../../models/invoice';
import { InvoiceFilter } from '../../models/invoice-filter';
import { Paginated } from '../../models/paginated';
import * as moment from 'moment';

@Injectable()

/**
 * WeekInvoicesResolver resolves request to get all paginated invoices for the current week
 */
export class WeekInvoicesResolver implements Resolve<Paginated<Invoice[]>>
{
	/**
	 * WeekInvoicesResolver constructor
	 *
	 * @param {InvoicesService} invoicesService
	 */
	constructor(private invoicesService: InvoicesService)
	{
	}

	/**
	 * Provides data to a route
	 *
	 * @returns {Observable<Paginated<Invoice[]>>}
	 */
	resolve(): Observable<Paginated<Invoice[]>>
	{
		let invoiceFilter = JSON.parse( localStorage.getItem('invoiceFilter') );

		if ( invoiceFilter != null )
		{
			return this.invoicesService.getPaginatedInvoices(0, invoiceFilter);
		}
		else
		{
			const filter: InvoiceFilter = {
				year: moment().year(),
				week: moment().isoWeek(),
				search: null
			};

			return this.invoicesService.getPaginatedInvoices(0, filter);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/resolvers/week-invoices.resolver.ts